/**
 * Ops UI app switcher. Wraps the shared `AppSwitcher` from
 * `@nova-integration/ui-shared` with ops-ui's app catalogue.
 *
 * URLs come from `getNovaEnv()` (`window.__NOVA_ENV__` injected by the BFF
 * in production, `REACT_APP_*` in CRA dev). For the *current* app we always
 * use `window.location.origin` as a safe fallback so the link is at least
 * a valid same-origin link even if env injection is missing.
 */
import React from 'react';
import { AppSwitcher as SharedAppSwitcher, AppDescriptor, getAppUrl } from '@nova-integration/ui-shared';
import { useAuthStore } from '../stores/authStore';
import { APP_ID } from '../lib/capabilities';

const buildApps = (): AppDescriptor[] => {
  const opsUrl = getAppUrl('ops-ui', APP_ID);
  const diaperUrl = getAppUrl('diaper-ui', APP_ID);
  const identityUrl = getAppUrl('identity', APP_ID);
  return [
    { id: 'ops-ui', label: 'Ops', url: opsUrl },
    { id: 'diaper-ui', label: 'Diaper / Sessions', url: diaperUrl },
    { id: 'identity', label: 'Identity Admin', url: identityUrl ? `${identityUrl}/admin-ui/` : '' },
  ].filter((a) => a.url) as AppDescriptor[];
};

export const AppSwitcher: React.FC<{ className?: string }> = ({ className }) => {
  const apps = React.useMemo(buildApps, []);
  return <SharedAppSwitcher apps={apps} currentAppId={APP_ID} useAuthStore={useAuthStore} className={className} />;
};
